import React, { createContext, useContext, useEffect } from 'react';
import { useLocalStorage } from '../hooks/useLocalStorage';
import { LANGUAGES, DIRECTIONS, STORAGE_KEYS } from '../shared/constants';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useLocalStorage(STORAGE_KEYS.LANGUAGE, LANGUAGES.ARABIC);
  const direction = language === LANGUAGES.ARABIC ? DIRECTIONS.RTL : DIRECTIONS.LTR;

  // Set initial direction on component mount and when language changes
  useEffect(() => {
    const isArabic = language === LANGUAGES.ARABIC;
    const dir = isArabic ? DIRECTIONS.RTL : DIRECTIONS.LTR;
    const lang = isArabic ? LANGUAGES.ARABIC : LANGUAGES.ENGLISH;
    
    document.documentElement.dir = dir;
    document.documentElement.lang = lang;
    document.body.style.direction = dir;
  }, [language]);

  const toggleLanguage = () => {
    const newLanguage = language === LANGUAGES.ARABIC ? LANGUAGES.ENGLISH : LANGUAGES.ARABIC;
    setLanguage(newLanguage);
  };

  const value = {
    language,
    direction,
    toggleLanguage,
    isArabic: language === LANGUAGES.ARABIC,
    isEnglish: language === LANGUAGES.ENGLISH,
    setLanguage
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};
